import type { FC, ReactNode } from 'react'

import { useRef } from 'react'

import { cn } from '@/lib/utils'
import { gsap, useGsap } from '@/lib/gsap'

interface RuleProps {
    className?: string
    delay?: number
}

/* Hairline that draws itself from the left as it scrolls in. The reference
   uses one between every list row. */
export const Rule: FC<RuleProps> = ({ className, delay = 0 }): ReactNode => {
    const scope = useRef<HTMLSpanElement>(null)

    useGsap(() => {
        const node = scope.current

        if (!node) {
            return
        }

        gsap.fromTo(node,
            { scaleX: 0 },
            {
                scaleX: 1,
                duration: 1.2,
                delay,
                ease: 'noma',
                scrollTrigger: {
                    trigger: node,
                    start: 'top 94%',
                    once: true
                }
            }
        )
    }, scope, [])

    return (
        <span
            ref={scope}
            aria-hidden='true'
            className={cn(
                'block h-px w-full origin-left bg-current opacity-20',
                className
            )}
        />
    )
}
